export const RICH_TEXT_TOOLBAR = [
  "heading",
  "|",
  "bold",
  "italic",
  "link",
  "bulletedList",
  "numberedList",
  "|",
  "outdent",
  "indent",
  "|",
  "uploadImage",
  "insertTable",
  "mediaEmbed",
  "blockQuote",
  "|",
  "undo",
  "redo",
];
